import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { EnvelopeOpen } from "@phosphor-icons/react";

export default function AdminLeads() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/leads").then(({ data }) => setData(data)).catch(() => {}); }, []);
  const leads = data?.leads || [];

  return (
    <AdminLayout>
      <div className="mb-6">
        <div className="overline text-navy/65 mb-1">Platform</div>
        <h1 className="font-heading font-black text-navy text-3xl tracking-tight">Trial leads</h1>
        <p className="text-navy/70 text-sm mt-1">Sign-ups captured from the marketing site ({data?.count ?? 0}).</p>
      </div>
      <div className="card-surface overflow-hidden">
        <table className="w-full text-sm" data-testid="leads-table">
          <thead>
            <tr className="text-left text-navy/65 border-b border-slate-100">
              <th className="px-5 py-3 font-semibold overline">Name</th>
              <th className="px-3 py-3 font-semibold overline">Email</th>
              <th className="px-3 py-3 font-semibold overline">Practice</th>
              <th className="px-3 py-3 font-semibold overline">Companies</th>
              <th className="px-3 py-3 font-semibold overline">Plan</th>
              <th className="px-5 py-3 font-semibold overline">When</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((l, i) => (
              <tr key={i} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/50">
                <td className="px-5 py-3 font-medium text-navy">{l.name}</td>
                <td className="px-3 py-3"><a href={`mailto:${l.email}`} className="text-orange hover:underline">{l.email}</a></td>
                <td className="px-3 py-3 text-navy/70">{l.practice || "—"}</td>
                <td className="px-3 py-3 text-navy/70">{l.companies ?? "—"}</td>
                <td className="px-3 py-3 text-navy/70 capitalize">{l.plan_id || "—"}</td>
                <td className="px-5 py-3 text-navy/65 text-xs">{l.created_at ? new Date(l.created_at).toLocaleDateString("en-GB") : "—"}</td>
              </tr>
            ))}
            {leads.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-12 text-center text-navy/65">
                <EnvelopeOpen size={28} className="mx-auto mb-2 text-navy/25" />No leads captured yet.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
